import React, { useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { PortfolioOverviewIcon } from "assets/material-custom-icons";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import queryString from "query-string";
import { usePortfolioConstructionActions, useSelectedBookmarkSelector, useUserActions } from "store";
import { CorrelationMatrixSettings, IBookmark, UrlQueryParams } from "store/types";

import { GroupItem } from "./GroupItem";

export const CorrelationMatrixBookmark: React.FC<IBookmark> = ({
  params,
  name,
  id,
  is_default,
  is_private,
  account_default,
  user,
  type
}) => {
  const { push } = useHistory();

  const { setCorrelationMatrixSettingsAction } = usePortfolioConstructionActions();
  const selectedBookmark = useSelectedBookmarkSelector();
  const { setSelectedBookmark } = useUserActions();

  const filteredEmail = params.replace(/(email.+)\+/g, "%2B");
  const { correlationMatrixSettings }: UrlQueryParams = queryString.parseUrl(filteredEmail).query;
  const bookmarkPath = params.split("?")[0];

  const handleClick = useCallback(() => {
    if (correlationMatrixSettings) {
      setSelectedBookmark(id);
      setCorrelationMatrixSettingsAction(JSON.parse(correlationMatrixSettings) as CorrelationMatrixSettings);
      setTimeout(() => push(bookmarkPath), 0);
    }
  }, [correlationMatrixSettings, bookmarkPath, id]);

  const isActive = useMemo(() => selectedBookmark === id, [selectedBookmark, id]);

  return (
    <GroupItem
      icon={
        <MaterialTooltip isShow placement="top" title="Correlation Matrix">
          <PortfolioOverviewIcon sx={{ fontSize: "18px", fill: "#071F35" }} />
        </MaterialTooltip>
      }
      id={id}
      title={name}
      ownerData={user}
      isActive={isActive}
      onClick={handleClick}
      allowSetDefault
      isDefault={is_default}
      isPrivate={is_private}
      isAccountDefault={account_default}
      bookmarkType={type}
    />
  );
};
